// src/components/AddSimPanel.js
import React, { useState } from 'react';
import api from './api';

const AddSimPanel = ({ onClose }) => {
    const [simNumber, setSimNumber] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [importFile, setImportFile] = useState(null);
    const [importMessage, setImportMessage] = useState('');

    const handleAddSingleSim = async (e) => {
        e.preventDefault();
        try {
            await api.post('/sims', { sim_number: simNumber, mobile_number: mobileNumber });
            setSimNumber('');
            setMobileNumber('');
            alert('SIM Added!');
        } catch (error) {
            alert('Error adding SIM');
        }
    };

    const handleImportSims = async (e) => {
        e.preventDefault();
        if (!importFile) return setImportMessage("Please select a CSV file first.");

        const formData = new FormData();
        formData.append('file', importFile);

        try {
            setImportMessage("Importing...");
            const response = await api.post('/sims/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setImportMessage(response.data.message);
            setImportFile(null);
        } catch (error) {
            setImportMessage("Error importing SIMs.");
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>Add / Import New SIMs</h2>
                    <button className="modal-close-btn" onClick={onClose}>&times;</button>
                </div>

                <div className="modal-body">
                    <form onSubmit={handleAddSingleSim}>
                        <label className="modal-label">SIM Number</label>
                        <input type="text" placeholder="SIM Number" value={simNumber} onChange={(e) => setSimNumber(e.target.value)} required />
                        
                        <label className="modal-label">Mobile Number</label>
                        <input type="text" placeholder="Mobile Number" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} required />
                        
                        <button type="submit" style={{ width: '100%', marginTop: '5px' }}>Add Single SIM</button>
                    </form>
                    
                    <hr style={{ margin: '25px 0', border: '0', borderTop: '1px solid var(--border-color)' }} />
                    
                    <h4 style={{ marginTop: 0, marginBottom: '15px', color: 'var(--primary)' }}>Import Multiple SIMs (CSV)</h4>
                    <form onSubmit={handleImportSims}>
                        <input type="file" accept=".csv" onChange={(e) => setImportFile(e.target.files[0])} />
                        <button type="submit" style={{ width: '100%', marginTop: '5px' }}>Import CSV</button>
                    </form>
                    {importMessage && (
                        <p style={{ color: 'var(--accent)', fontWeight: 'bold', marginTop: '15px', textAlign: 'center' }}>
                            {importMessage}
                        </p>
                    )}
                </div>

            </div>
        </div>
    );
};

export default AddSimPanel;
